import { DEFAULT_PLACEHOLDER } from '@helpers';

const getMachineNames = (version: Record<string, unknown> | null | undefined): string => {
  const names = [version?.firstRanByMachineName, version?.lastRanByMachineName].filter(
    (name): name is string => !!name
  );
  const unique = [...new Set(names)];
  if (unique.length > 0) return unique.join(', ');
  if (typeof version?.createdBy === 'string') return version.createdBy;
  return DEFAULT_PLACEHOLDER;
};

export default getMachineNames;
